import * as type from "../../types/API/inventoryApprovalType";

export function getInventoryApprovals(payload: any) {
  return {
    type: type.GET_INVENTORY_APPROVAL,
    payload: payload,
  };
}

export function getInventoryApprovalById(payload: any) {
  return {
    type: type.GET_INVENTORY_APPROVAL_BY_ID,
    payload: payload,
  };
}

export function acceptRejectApproval(payload: any) {
  return {
    type: type.ACCEPT_REJECT_APPROVAL,
    payload: payload,
  };
}